import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";
import Button from "@material-ui/core/Button";
import SalesCTA from "../../components/buttons/SalesCTA";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default function Pricing() {
  const [billingCycle, setBillingCycle] = useState("monthly"); // 'monthly' | 'yearly'

  const pricingTiers = [
    {
      name: "Lite",
      badge: "Untuk UMKM & Bisnis Baru",
      priceMonthly: "60",
      priceYearly: "50",
      desc: "Solusi praktis untuk kedai kopi, booth minuman, atau UMKM yang butuh kasir handal.",
      featured: false,
      buttonText: "Pilih Paket Lite",
      buttonVariant: "outlined",
      features: [
        "Aplikasi POS Kasir (Android & iOS)",
        "Digital Menu & Manajemen Kategori",
        "Laporan Ringkasan Penjualan Harian",
        "Perhitungan Biaya Pokok (COGS) Dasar",
        "Aplikasi Pemilik Usaha (Owner App)",
        "Rekap Transaksi via Email",
        "Dukungan Layanan Pelanggan",
      ],
    },
    {
      name: "Business",
      badge: "Paling Populer",
      priceMonthly: "314",
      priceYearly: "239",
      desc: "Fitur lengkap untuk restoran dan cafe yang membutuhkan kontrol operasional menyeluruh.",
      featured: true,
      buttonText: "Coba Business Gratis",
      buttonVariant: "contained",
      features: [
        "Semua fitur di Paket Lite",
        "Manajemen Inventory & Stok Bahan Baku",
        "Manajemen Resep & Bundling Menu",
        "Laporan Laba Kotor & Analisis Margin",
        "Analisis Jam Ramai & Tren Penjualan",
        "Shift Kasir & Rekap Absensi Staf",
        "Sistem Kupon Diskon & Voucher Promo",
        "Feedback & Rating dari Pelanggan",
        "Smart Waiter Auto-Upselling",
      ],
    },
    {
      name: "Professional",
      badge: "Multi-Outlet & Skala Besar",
      priceMonthly: "899",
      priceYearly: "749",
      desc: "Paket terlengkap untuk bisnis multi-cabang dengan volume transaksi tinggi.",
      featured: false,
      buttonText: "Pilih Professional",
      buttonVariant: "outlined",
      features: [
        "Semua fitur di Paket Business",
        "Manajemen Multi-Cabang / Multi-Outlet",
        "Centralized Inventory & Transfer Stok Antar Cabang",
        "Sistem Reservasi Meja Khusus",
        "CRM & Tingkat Keanggotaan Pelanggan (Loyalty)",
        "Dedicated Account Manager",
        "Prioritas Dukungan Teknis 24/7",
      ],
    },
  ];

  const pricingFaqs = [
    {
      q: "Apakah ada masa uji coba gratis (Free Trial)?",
      a: "Ya! Anda dapat mencoba semua fitur UR secara gratis selama 14 hari tanpa perlu memasukkan informasi kartu kredit.",
    },
    {
      q: "Apakah saya bisa berganti paket di tengah periode langganan?",
      a: "Tentu saja. Anda dapat melakukan upgrade atau penyesuaian paket kapan saja melalui backoffice atau dengan menghubungi tim support kami.",
    },
    {
      q: "Perangkat apa saja yang didukung oleh UR?",
      a: "UR dapat digunakan di smartphone atau tablet Android, iPad / iPhone (iOS), serta laptop/komputer melalui web browser.",
    },
    {
      q: "Bagaimana proses setup dan pelatihan staf?",
      a: "Tim Support kami siap memandu proses setup daftar menu, konfigurasi meja, dan pelatihan staf Anda.",
    },
  ];

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>Paket &amp; Harga | Aplikasi POS &amp; Self Order UR</title>
        <meta
          name="title"
          content="Paket & Harga | Aplikasi POS & Self Order UR"
        />
        <meta
          name="description"
          content="Pilihan paket harga transparan aplikasi POS dan Self Order UR untuk restoran, cafe, dan UMKM di Indonesia."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/pricing" />
      </MetaTags>

      {/* Header Banner */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "60px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "6px 14px",
              borderRadius: "9999px",
              backgroundColor: "rgba(255, 255, 255, 0.08)",
              border: "1px solid rgba(255, 255, 255, 0.15)",
              marginBottom: "16px",
            }}
          >
            <span
              style={{
                color: "#f1f5f9",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              Harga Transparan Tanpa Biaya Tersembunyi
            </span>
          </div>

          <Typography
            variant="h1"
            style={{
              fontWeight: 800,
              fontSize: "clamp(2rem, 4vw, 3.2rem)",
              lineHeight: 1.2,
              letterSpacing: "-0.02em",
              marginBottom: "14px",
            }}
          >
            Pilihan Paket Sesuai Skala Bisnis Anda
          </Typography>

          <p
            style={{
              color: "#94a3b8",
              fontSize: "15px",
              maxWidth: "560px",
              margin: "0 auto 28px auto",
              lineHeight: 1.6,
            }}
          >
            Mulai dari paket usaha rintisan hingga multi-cabang. Semua paket mencakup pembaruan sistem dan dukungan pelanggan.
          </p>

          {/* Billing Switch */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.06)",
              padding: "4px",
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.12)",
            }}
          >
            <button
              onClick={() => setBillingCycle("monthly")}
              style={{
                padding: "8px 18px",
                borderRadius: "6px",
                border: "none",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.15s ease",
                backgroundColor:
                  billingCycle === "monthly" ? "#DE148C" : "transparent",
                color: billingCycle === "monthly" ? "#ffffff" : "#94a3b8",
              }}
            >
              Bulanan
            </button>
            <button
              onClick={() => setBillingCycle("yearly")}
              style={{
                padding: "8px 18px",
                borderRadius: "6px",
                border: "none",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.15s ease",
                backgroundColor:
                  billingCycle === "yearly" ? "#DE148C" : "transparent",
                color: billingCycle === "yearly" ? "#ffffff" : "#94a3b8",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              Tahunan
              <span
                style={{
                  fontSize: "11px",
                  padding: "1px 6px",
                  borderRadius: "4px",
                  backgroundColor: "#22c55e",
                  color: "#ffffff",
                  fontWeight: 700,
                }}
              >
                Hemat s/d 20%
              </span>
            </button>
          </div>
        </Container>
      </section>

      {/* 3-Tier Pricing Cards */}
      <section
        style={{
          padding: "60px 0 80px 0",
          backgroundColor: "#f8fafc",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={3} alignItems="stretch" justify="center">
            {pricingTiers.map((tier, idx) => (
              <Grid item xs={12} md={4} key={idx}>
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "16px",
                    padding: "32px 24px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    position: "relative",
                    border: tier.featured
                      ? "2px solid #DE148C"
                      : "1px solid #e2e8f0",
                    boxShadow: tier.featured
                      ? "0 8px 24px -4px rgba(222, 20, 140, 0.15)"
                      : "0 1px 3px rgba(0, 0, 0, 0.04)",
                  }}
                >
                  <div>
                    {/* Header */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          padding: "4px 10px",
                          borderRadius: "6px",
                          backgroundColor: tier.featured
                            ? "rgba(222, 20, 140, 0.1)"
                            : "#f1f5f9",
                          color: tier.featured ? "#DE148C" : "#64748b",
                        }}
                      >
                        {tier.badge}
                      </span>
                    </div>

                    <Typography
                      variant="h4"
                      style={{
                        fontWeight: 800,
                        fontSize: "22px",
                        color: "#0f172a",
                        marginBottom: "6px",
                      }}
                    >
                      {tier.name}
                    </Typography>

                    <p
                      style={{
                        color: "#64748b",
                        fontSize: "13px",
                        lineHeight: 1.5,
                        minHeight: "38px",
                        marginBottom: "20px",
                      }}
                    >
                      {tier.desc}
                    </p>

                    {/* Price */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                        marginBottom: "24px",
                        paddingBottom: "20px",
                        borderBottom: "1px solid #f1f5f9",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#64748b",
                        }}
                      >
                        Rp
                      </span>
                      <span
                        style={{
                          fontSize: "36px",
                          fontWeight: 800,
                          letterSpacing: "-0.03em",
                          color: "#0f172a",
                        }}
                      >
                        {billingCycle === "yearly"
                          ? tier.priceYearly
                          : tier.priceMonthly}
                        rb
                      </span>
                      <span
                        style={{
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        / bulan
                      </span>
                    </div>

                    {/* Features List */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        marginBottom: "32px",
                      }}
                    >
                      {tier.features.map((feat, fIdx) => (
                        <div
                          key={fIdx}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              color: "#16a34a",
                              fontWeight: 700,
                              fontSize: "13px",
                              flexShrink: 0,
                              marginTop: "1px",
                            }}
                          >
                            ✓
                          </span>
                          <span
                            style={{
                              fontSize: "13px",
                              lineHeight: 1.4,
                              color: "#334155",
                            }}
                          >
                            {feat}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Action Button */}
                  <div>
                    {tier.featured ? (
                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          backgroundColor: "#DE148C",
                          color: "#ffffff",
                          fontWeight: 600,
                          fontSize: "14px",
                          padding: "10px",
                          borderRadius: "8px",
                          textTransform: "none",
                          boxShadow: "none",
                        }}
                        href="https://partner.ur-hub.com/landing?utm_source=pricing&utm_medium=cta&utm_id=registration"
                        target="_blank"
                      >
                        {tier.buttonText}
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        variant="outlined"
                        style={{
                          borderColor: "#cbd5e1",
                          color: "#0f172a",
                          fontWeight: 600,
                          fontSize: "14px",
                          padding: "10px",
                          borderRadius: "8px",
                          textTransform: "none",
                          backgroundColor: "#ffffff",
                        }}
                        href="https://partner.ur-hub.com/landing?utm_source=pricing&utm_medium=cta&utm_id=registration"
                        target="_blank"
                      >
                        {tier.buttonText}
                      </Button>
                    )}
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      {/* Pricing FAQs */}
      <section style={{ padding: "64px 0", backgroundColor: "#ffffff" }}>
        <Container maxWidth="md">
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <Typography
              variant="h3"
              style={{
                fontWeight: 800,
                color: "#0f172a",
                fontSize: "24px",
                marginBottom: "8px",
              }}
            >
              Pertanyaan Seputar Paket &amp; Langganan
            </Typography>
            <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
              Informasi penting seputar aktivasi, pembayaran, dan dukungan teknis.
            </p>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {pricingFaqs.map((faq, idx) => (
              <Accordion
                key={idx}
                elevation={0}
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: "10px",
                  marginBottom: "6px",
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: "#64748b" }} />}
                >
                  <Typography style={{ fontWeight: 600, fontSize: "15px", color: "#0f172a" }}>
                    {faq.q}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ paddingTop: 0 }}>
                  <Typography style={{ color: "#64748b", fontSize: "14px", lineHeight: 1.6 }}>
                    {faq.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </Container>
      </section>

      {/* Enterprise Consultation Banner */}
      {/*<section
        style={{
          padding: "56px 0",
          backgroundColor: "#0f172a",
          color: "#ffffff",
          borderTop: "1px solid #1e293b",
        }}
      >
        <Container maxWidth="md" style={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            style={{ fontWeight: 700, fontSize: "22px", marginBottom: "10px" }}
          >
            Mengelola Lebih dari 10 Cabang Restoran?
          </Typography>
          <p
            style={{
              color: "#94a3b8",
              fontSize: "14px",
              maxWidth: "500px",
              margin: "0 auto 24px auto",
            }}
          >
            Dapatkan penawaran enterprise kustom, SLA server khusus, dan integrasi akuntansi sesuai kebutuhan bisnis Anda.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <SalesCTA text="Konsultasi Enterprise" />
          </div>
        </Container>
      </section>*/}
    </div>
  );
}
